var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"note"}},[_c('p',[_vm._v("本サイト内の情報は艦隊これくしょんwikiを参考に、SNS等から収集しています。\n    "),_c('br'),_vm._v("性質上検証が難しいため反映が不十分なケースがあることをご了承願います。\n    "),_c('br'),_vm._v("本サイトを利用した上で発生したいかなる損害においても、管理者は責任を負わないものとします。\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8e0502","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Note.vue
// module id = null
// module chunks = 